module.exports = __webpack_public_path__ + "static/media/homebg.af97f568.png";